<template lang="html">

  <section class="recetario row-center ais banner-child-vive animation" :id="$t('banners_experiencia.recetario.id')">

    <div class="imagen">
      <article class="banner-recetario row-center plum-border -xl">
        <router-link :to="$t('enlaces.recetario')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.recetario')" class="btn">
          <span v-html="$t('banners_experiencia.recetario.boton')"></span>
        </router-link>
      </article>
    </div>

    <div class="texto column-center">
      <div class="container -half">
        <h2 class="title" v-html="$t('banners_experiencia.recetario.titulo')"></h2>
        <div v-html="$t('banners_experiencia.recetario.cuerpo')"></div>
      </div>
    </div>

  </section>

</template>

<script lang="js">
 export default  {
  name: 'banner-enoturismo',
}
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .recetario{
    width: 100%;
    background: $plum;
  }

  p{
    text-align: justify;
  }

  .texto{
    background: $plum;
  }

  .recetario > div{
    width: 50%;
  }

  @media screen and (max-width: 1023px){
    .recetario > div{
      width: 100%;
      height: auto;
      padding: 50px 25px;
      &.texto{
        padding: 50px 0 0 0;
        order: -1;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/parts/banner-recetario.vue